import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  C8_P2_S1_Title: {
    id: `case01.page02.slide01.title`,
  },
  C8_P2_S1_Description: {
    id: `case01.page02.slide01.description`,
  },
  C8_P2_S1_Button1_Label: {
    id: `case01.page02.slide01.button1.label`,
  },
  C8_P2_S1_Button2_Label: {
    id: `case01.page02.slide01.button2.label`,
  },
  C8_P2_S1_Button3_Label: {
    id: `case01.page02.slide01.button3.label`,
  },
  C8_P2_S1_Button4_Label: {
    id: `case01.page02.slide01.button4.label`,
  },
  C8_P2_S1_Button5_Label: {
    id: `case01.page02.slide01.button5.label`,
  },
  C8_P2_M_PhysicalPrototyping_Title: {
    id: `case01.page02.modal.physical_prototyping.title`,
  },
  C8_P2_M_PhysicalPrototyping_Description: {
    id: `case01.page02.modal.physical_prototyping.description`,
  },
  C8_P2_M_VirtualPrototyping_Title: {
    id: `case01.page02.modal.virtual_prototyping.title`,
  },
  C8_P2_M_VirtualPrototyping_Description: {
    id: `case01.page02.modal.virtual_prototyping.description`,
  },
  C8_P2_M_MusicSystems_Title: {
    id: `case01.page02.modal.music_systems.title`,
  },
  C8_P2_M_MusicSystems_Description: {
    id: `case01.page02.modal.music_systems.description`,
  },
  C8_P2_M_AudioZones_Title: {
    id: `case01.page02.modal.audio_zones.title`,
  },
  C8_P2_M_AudioZones_Description: {
    id: `case01.page02.modal.audio_zones.description`,
  },
  C8_P2_M__DirectionalAlerts_Title: {
    id: `case01.page02.modal.directional_alerts.title`,
  },
  C8_P2_M__DirectionalAlerts_Description: {
    id: `case01.page02.modal.directional_alerts.description`,
  },
});
